<template>
  <p class="mb-2">{{ $t('LOGIN.REMIND_PASSWORD_DESC') }}</p>
  <form @submit.prevent="submitMagicLink">
    <v-text-field id="emailField" v-model="email" :placeholder="emailPlaceholder || $t('GLOBAL.EMAIL')" :hide-details="false" :error-messages="error" :messages="success"
                  prepend-inner-icon="far fa-at" autofocus>
    </v-text-field>
    <div class="text-center mt-2">
      <v-btn :disabled="! email || isSubmittingRemind" color="primary" rounded size="large" type="submit" block>
        {{ $t('LOGIN.MAGIC_LINK') }}
      </v-btn>
      <div class="my-3">{{ $t('GLOBAL.OR') }}</div>
      <v-btn :disabled="! email || isSubmittingRemind" variant="outlined" color="primary" rounded size="large" block @click="submitRemindPassword">{{ $t('LOGIN.REMIND_PASSWORD') }}</v-btn>
    </div>
  </form>
  <div class="mt-12"></div>
  <div class="mt-auto text-center">
    <v-btn variant="text" @click.prevent="$emit('navigate-section', 'register')">{{ $t('LOGIN.CREATE_ACCOUNT') }}</v-btn>
  </div>
</template>

<script>
  export default {
    emits: ['navigate-section'],
    data() {
      return {
        email: "",
        error: "",
        success: "",
        emailPlaceholder: "",
        isSubmittingRemind: false,
      };
    },
    methods: {
      submitMagicLink() {
        this.submitRequest('auth/magic-link');
      },
      submitRemindPassword() {
        this.submitRequest('password/remind');
      },
      submitRequest(endpoint) {
        this.error = "";
        this.success = "";
        if (! window.isValidEmailAddress(this.email)) {
          this.error = this.$t('LOGIN.ERROR_INVALID_EMAIL');
          return;
        }

        this.isSubmittingRemind = true;
        window.apiSrv.call(endpoint, 'store', { email: this.email }).then((response) => {
          this.success = response?.data?.message;
          this.emailPlaceholder = this.email;
          this.email = "";
          this.isSubmittingRemind = false;
        }).catch((error) => {
          if (typeof error == 'object') {
            this.error = Object.keys(error).map((key) => {
              const messages = error[key];
              if (Array.isArray(messages)) return `- ${messages.join('\n- ')}`;
              return messages;
            }).join("\n");
          } else {
            this.error = error;
          }
          this.isSubmittingRemind = false;
        });
      },
    },
  };
</script>
